import React, { useState } from 'react';

const ActivateSellerModal = ({ show, onClose, onSubmit, sellerEmail, isLoading }) => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        businessMcc: '',
        dob: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const isoDob = formData.dob ? new Date(formData.dob).toISOString() : '';

        onSubmit({
            ...formData,
            dob: isoDob,
        });
    };

    if (!show) return null;

    return (
        <>
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" style={{ color: '#000', fontWeight: 'bold' }}>Activate Seller</h5>
                            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p style={{ color: '#333' }}>Activating seller: <strong style={{ color: '#000' }}>{sellerEmail}</strong></p>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label" style={{ color: '#000', fontWeight: '500' }}>First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                        style={{ color: '#000' }}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label" style={{ color: '#000', fontWeight: '500' }}>Last Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                        style={{ color: '#000' }}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label" style={{ color: '#000', fontWeight: '500' }}>Business MCC</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="businessMcc"
                                        value={formData.businessMcc}
                                        onChange={handleChange}
                                        required
                                        style={{ color: '#000' }}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label" style={{ color: '#000', fontWeight: '500' }}>Date of Birth</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        required
                                        style={{ color: '#000' }}
                                    />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isLoading}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? 'Activating...' : 'Activate'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ActivateSellerModal;
